import { fetchApi } from '@/config/axiosSetting.ts';
import {
  DownloadHealthCertificationQueryResponseType,
  DownloadHealthCertificationZipType,
} from '@/modules/FileDetail/queries/documentation/downloadZip/downloadHealthCertification/downloadHealthCertificationQuery.type';

export const downloadHealthCertificationQueryFunction = ({
  id,
  show_image,
}: DownloadHealthCertificationZipType): Promise<DownloadHealthCertificationQueryResponseType> =>
  fetchApi.get(`documents/${id}/health_certificate/response/`, {
    params: { show_image },
  });
